// extracted by mini-css-extract-plugin
module.exports = {"main":"Author_main__3IJmX","title":"Author_title__AQrKT","list":"Author_list__1EaUa","url":"Author_url__2ZPoc","listItem":"Author_listItem__3JN1P"};